// Foresight checklist (#830): choosing the run (one foresight scenario), and steps 4–5,
// preferred_future.v1 and backcasting.v1.
// Merged into the `foresight` namespace next to foresightStrings.js.

export const foresightPathFi = {
  runAdmin: {
    acceptTitle: 'Jatkotyöhön otettavat skenaariot',
    publishTitle: 'Muille moduuleille julkaistavat skenaariot',
    noRuns: 'Skenaarioita ei ole vielä aloitettu.',
    noApprovedRuns: 'Yhdenkään skenaarion tulevaisuuskuvia ei ole vielä hyväksytty.',
    accept: 'Jatkotyöhön',
    leaveOut: 'Ei jatkoon',
    undecided: 'Ei vielä valittu',
    allGoOn: 'Jatkotyössä automaattisesti',
    published: 'Julkaistu',
    notPublished: 'Ei julkaistu',
    publish: 'Julkaise',
    withdraw: 'Peru julkaisu',
    withdrawHasContent: 'Vaikutuskartalla on jo sisältöä tämän skenaarion pohjalta, joten julkaisua ei voi perua.',
  },
  run: {
    waiting: 'Skenaario "{{title}}" odottaa, että fasilitaattori ottaa sen jatkotyöhön. Voit sillä välin työstää sen rajausta tai valita toisen skenaarion.',
    leftOut: 'Fasilitaattori ei ottanut skenaariota "{{title}}" jatkotyöhön. Valitse toinen skenaario.',
    acceptance: { accepted: 'Jatkotyössä', leftOut: 'Ei jatkotyössä', waiting: 'Odottaa valintaa' },
    title: 'Skenaario',
    lead: 'Jokainen ennakointi on yksi Kuution skenaario: sille rajataan tarkasteltava asia, valitaan muutosvoimat ja muodostetaan kolme tulevaisuuskuvaa, joista rakennetaan tavoiteltava tulevaisuus ja toimintapolku. Aloita uusi skenaario tai jatka aiemmin aloitettua.',
    existing: 'Aloitetut skenaariot',
    new: 'Uusi skenaario',
    namePlaceholder: 'Skenaarion nimi, esim. Riskienhallinta 2031',
    create: 'Aloita skenaario',
    continue: 'Jatka tätä',
    chosen: 'Valittu',
    briefFor: 'Skenaarion rajaus',
    listTitle: 'Valitse skenaario',
    listLead: 'Valitse skenaario, jota työstät tässä vaiheessa.',
    navList: 'Skenaariot',
    state: { done: 'Valmis', open: 'Kesken', waitsFor: 'Odottaa: {{step}}' },
    rename: 'Nimeä uudelleen',
    editRun: 'Muokkaa nimeä ja omistajaa',
    owner: 'Omistaja',
    ownerPlaceholder: 'Omistaja (vapaaehtoinen): kuka rakensi skenaarion ja vastaa kysymyksiin',
    ownerOf: 'Omistaja: {{name}}',
    chooseFirst: 'Valitse ensin skenaario, jota työstät, tai aloita uusi Rajaus-vaiheessa.',
    next: 'Seuraava vaihe: {{step}}',
    stepsLabel: 'Ennakoinnin vaiheet',
    stepOf: 'Vaihe {{n}}/{{total}}',
  },
  preferred: {
    title: 'Tavoiteltava tulevaisuus',
    lead: 'Tavoiteltava tulevaisuus ei ole yksi tulevaisuuskuvista vaan tietoinen valinta, jonka puolesta olette valmiita toimimaan. Poimi skenaarion tulevaisuuskuvista piirteitä: mitä edistetään, mitä vältetään, mihin sopeudutaan ja mihin voitte vaikuttaa. Tekoäly luonnostelee ja nostaa esiin jännitteet, valinta on sinun.',
    questionsTitle: 'Apukysymyksiä',
    questions: {
      mustBeTrue: 'Mitä pitäisi olla totta tavoitevuonna?',
      prevent: 'Mitä kehitystä haluamme ehkäistä?',
      values: 'Millaisia arvoja valintamme ilmentää?',
      inPractice: 'Miten muutos näkyisi käytännössä?',
    },
    featuresTitle: 'Tulevaisuuskuvien piirteet',
    featuresLead: 'Lisää piirre johonkin neljästä ryhmästä. Samaa piirrettä voi käyttää vain kerran, ja valinnan voi palauttaa listaan ja ryhmitellä uudelleen.',
    noScenarios: 'Skenaariolla ei ole hyväksyttyjä tulevaisuuskuvia. Hyväksy ne ensin.',
    kinds: { opportunity: 'Mahdollisuus', risk: 'Riski' },
    takenAs: 'Lisätty: {{group}}',
    returnToList: 'Palauta listaan',
    moveTo: 'Siirrä toiseen ryhmään',
    addTo: 'Lisää ryhmään…',
    groupsTitle: 'Valitut piirteet',
    groups: { promote: 'Edistetään', avoid: 'Vältetään', adaptTo: 'Sopeudutaan', canInfluence: 'Voimme vaikuttaa' },
    groupHints: {
      promote: 'Toivottu kehitys, jota vahvistamme omilla toimillamme',
      avoid: 'Ei-toivottu kehitys, jota ehkäisemme',
      adaptTo: 'Kehitys, johon emme voi vaikuttaa mutta johon varaudumme',
      canInfluence: 'Asia, jonka suuntaa organisaatio voi itse muuttaa, oli se toivottu tai ei',
    },
    fromFuture: 'Tulevaisuuskuvasta: {{title}}',
    own: 'Oma piirre',
    ownPlaceholder: 'Oma piirre',
    futureTitle: 'Tulevaisuuskuva',
    valuesBasis: 'Arvot ja tavoitteet, joihin valinta perustuu',
    valuesBasisHint: 'Tähän käyvät sekä organisaation arvot (esimerkiksi sen strategiasta) että oma näkemyksesi kehitystyön arvoista ja tavoitteista. Rajauksen tavoite kertoo, mitä tavoitellaan; tämä kertoo, miksi. Arvot ohjaavat koko toimintapolkua, eivät vain tätä luonnosta.',
    draftHint: 'Luonnos rakentuu valitsemistasi piirteistä ja arvoista eikä muuta niitä. Lue teksti läpi ja korjaa, mikä on sanottu väärin: lopullinen sisältö on sinun.',
    draft: 'Luonnostele tekoälyllä',
    draftReplace: 'Korvaa ja luonnostele',
    draftNeedsFeatures: 'Valitse ensin piirteitä.',
    confirmOverwrite: 'Tekoälyn luonnos korvaa nykyisen kuvauksen, onnistumisen ehdot, muutosvoimien kuvaukset ja jännitteet. Valitut piirteet sekä arvot ja tavoitteet säilyvät. Jatketaanko?',
    description: 'Kuvaus tavoitevuoden tilanteesta',
    descriptionHint: 'Lue kuvaus läpi ja tarkista, että kaikki on sanottu oikein. Tekoäly tulkitsee valintasi, ja pienet virhetulkinnat ovat tavallisia.',
    successConditions: 'Onnistumisen ehdot: mitä on totta tavoitevuonna',
    onePerLine: 'Yksi ehto riville',
    driverOutcomesTitle: 'Muutosvoimat tavoiteltavassa tulevaisuudessa',
    driverOutcomesLead: 'Miltä kukin muutosvoima näyttää tavoitevuonna. Hyväksyttäessä näistä tulee skenaarion neljäs tulevaisuuskuva, jota tulevaisuuskuvan valinta ja vaikutuskartta voivat käyttää.',
    tensionsTitle: 'Jännitteet ratkaistavaksi',
    tensionResolved: 'käsitelty',
    tensionsLead: 'Tekoäly nosti nämä esiin valitsemiesi piirteiden välisistä ristiriidoista. Käy ne läpi asiantuntemuksesi pohjalta: muokkaa epätarkka, poista epäosuva ja merkitse käsitellyksi, kun olet ottanut jännitteen huomioon. Jännitteitä ei ratkaista tässä: ratkaisut rakennetaan backcasting-polulla. Jännitteet, joita et poista, siirtyvät polun tekoälylle ja raporttiin. Mikään jännite ei ole pakollinen: tulevaisuuskuvan voi hyväksyä, vaikka yhtään ei olisi merkitty.',
    approve: 'Hyväksy tulevaisuuskuva',
    approved: 'Tavoiteltava tulevaisuus on hyväksytty ja tallennettu skenaarion tulevaisuuskuvaksi. Jos muokkaat sitä, hyväksy uudelleen.',
  },
  backcasting: {
    title: 'Backcasting',
    lead: 'Rakenna polkua tavoiteltavasta tulevaisuudesta takaisin nykyhetkeen. Tarkastele kutakin vaihetta kokonaisuutena: mitä tässä vaiheessa täytyy olla olemassa tai tapahtua, jotta seuraava vaihe ja lopulta tavoitetila voivat toteutua? Lisää polulle tarpeen mukaan ehtoja, käännekohtia, päätöksiä, valmiuksia, resursseja, kumppanuuksia ja toimenpiteitä. Kun avaat vaiheen, tekoäly ehdottaa ensin, kuinka pitkällä tavoitetilan kunkin ulottuvuuden pitää olla: hyväksy, korjaa tai pudota ehdotukset ennen kuin täydennät vaiheen. Apukysymyksiä ja luonnoksia saat pyytämällä; ne ovat lähtökohtia, eivät vastauksia.',
    timelineTitle: 'Polku tavoitevuoteen {{year}}',
    yearsHint: 'Napsauta vaihetta avataksesi sen ja vuotta muuttaaksesi sitä. T0 on nykyhetki: jos työ alkaa vasta ensi vuonna, vaihda sen vuosi.',
    overviewEmpty: 'Ei vielä kohtia',
    targetTitle: 'Tavoitetila {{year}}',
    targetColumn: 'Tavoitevuosi',
    targetEmpty: 'Onnistumisen ehdot kirjataan tavoiteltavassa tulevaisuudessa.',
    targetConditions: 'Onnistumisen ehdot',
    targetDimensions: 'Tavoitetilan ulottuvuudet',
    targetDimensionsHint: 'Tavoitetila muutamana avainsanana, yksi riville, esim. Yksi yhteinen tietovaranto',
    targetDimensionsAdd: 'Kirjaa avainsanat',
    targetDimensionsEdit: 'Muokkaa avainsanoja',
    manyItems: 'Vaiheessa on jo {{n}} kohtaa. Harvat, painavat kohdat pitävät polun luettavana: yhdistä tai karsi, jos voit.',
    stage: 'Vaihe',
    copyTo: 'Kopioi vaiheeseen',
    copyHint: 'Kopio tulee valittuun vaiheeseen omaksi kohdakseen, jota voit muokata:',
    stageYear: 'Vaiheen {{stage}} vuosi',
    stagesLabel: 'Polun vaiheet',
    stageTitle: '{{stage}} · {{year}}',
    stageHints: {
      T4: 'Viimeinen vaihe ennen tavoitevuotta: tavoitetila ei ole vielä toteutunut. Mikä on silloin valmiina, ja mikä oli viimeinen ratkaiseva muutos?',
      T3: 'Mitä piti olla totta, jotta viimeinen vaihe oli mahdollinen? Mikä käännekohta tähän liittyy?',
      T2: 'Mitkä päätökset ja kyvyt tämän vaiheen piti saada aikaan?',
      T1: 'Mitä piti olla valmiina, jotta muutos pääsi käyntiin?',
      T0: 'Mitä aloitetaan nyt? Polku tarvitsee tähän vaiheeseen ainakin yhden toimenpiteen.',
    },
    stageEmpty: 'Tässä vaiheessa ei ole vielä mitään.',
    freeEdit: 'Vapaa muokkaus',
    freeEditHint: 'Avaa kaikki vaiheet kerralla, kun haluat täydentää polkua muussa kuin T4→T0-järjestyksessä. Tallennettuun polkuun tämä ei vaikuta.',
    stageGated: 'Backcasting etenee tulevaisuudesta nykyhetkeen: vaihe {{stage}} ({{year}}) on vielä tyhjä. Aloita sieltä, tai salli vapaa muokkaus.',
    goToStage: 'Siirry vaiheeseen {{stage}}',
    addItem: 'Lisää kohta',
    askAssist: 'Apukysymykset ja luonnokset',
    kind: 'Laji',
    text: 'Mitä tässä vaiheessa tapahtuu tai on totta?',
    kinds: {
      condition: 'Ehto', turning_point: 'Käännekohta', decision: 'Päätös', capability: 'Osaaminen',
      resource: 'Resurssi', partnership: 'Kumppanuus', action: 'Toimenpide', indicator: 'Indikaattori',
    },
    kindHints: {
      condition: 'Mikä pitää olla totta tässä vaiheessa, jotta polku jatkuu',
      turning_point: 'Käänne, jonka jälkeen suunta on toinen: polun tärkeimmät kohdat',
      decision: 'Kuka päättää ja mitä',
      capability: 'Mitä pitää osata tai hallita: osaaminen ja toimintatavat',
      resource: 'Raha, aika, henkilöt, tilat, data',
      partnership: 'Kenen kanssa tämä tehdään',
      action: 'Konkreettinen teko, jolla on tekijä ja ajankohta',
      indicator: 'Kuinka pitkällä tavoitetilan ulottuvuus on tämän vaiheen vuonna',
    },
    showDetails: 'Vastuu, mittari, este, perustelu…',
    hideDetails: 'Piilota lisätiedot',
    details: { responsibility: 'Vastuu', metric: 'Mittari', obstacle: 'Este', remedy: 'Ratkaisu esteeseen', rationale: 'Perustelu' },
    detailHints: {
      responsibility: 'Kuka vastaa tästä kohdasta',
      metric: 'Mistä näkee, että tämä on toteutunut',
      obstacle: 'Mikä voi estää tämän kohdan toteutumisen',
      remedy: 'Miten este ylitetään',
      rationale: 'Miksi tämä kohta kuuluu polulle juuri tässä vaiheessa',
    },
    fromAi: 'Tekoälyn luonnos',
    dimension: 'Ulottuvuus',
    stageSteps: 'Käy ensin indikaattoriehdotukset läpi, ja täydennä sitten vaihe itse: mitä tässä vaiheessa täytyy olla olemassa tai tapahtua, jotta seuraava vaihe voi toteutua?',
    indicatorsTitle: 'Tavoitetilan ulottuvuudet {{year}}',
    indicatorsLead: 'Kuinka pitkällä kunkin ulottuvuuden pitää olla tämän vaiheen vuonna. Tekoälyn ehdotukset ovat lähtökohta: hyväksy, muokkaa tai hylkää jokainen.',
    indicatorProposals: 'Tekoälyn ehdotukset',
    indicatorNone: 'Ei välietappia tässä vaiheessa',
    indicatorWrite: 'Kirjaa itse',
    suggestIndicators: 'Ehdota indikaattorit',
    suggestIndicatorsAgain: 'Ehdota indikaattorit uudelleen',
    needsDimensions: 'Kirjaa tavoitetilan ulottuvuudet avainsanoina tavoitevuoden sarakkeeseen, niin tekoäly ehdottaa jokaiselle indikaattorin vaihe kerrallaan.',
    metricSuggest: 'Ehdota mittari',
    metricSuggestAgain: 'Ehdota parempi mittari',
    metricProposal: 'Tekoälyn ehdotus',
    metricUse: 'Käytä',
    metricDrop: 'Hylkää',
    reviewSuggestion: 'Ehdotus vaiheeseen {{stage}}',
    reviewAdd: 'Lisää polkuun',
    reviewAdded: 'Lisätty polkuun',
    changedByStressTest: 'Muutettu stressitestissä',
    questionsTitle: 'Apukysymykset',
    questionsLead: 'Kysymykset ja luonnokset ovat suuntaa-antavia. Jos termi tai ehdotus ei osu, ohita se ja kirjaa kohta omin sanoin.',
    draftsTitle: 'Luonnokset',
    reviewTitle: 'Polun arviointi',
    review: 'Arvioi polku',
    reviewAgain: 'Arvioi uudelleen',
    reviewLead: 'Tekoäly tarkistaa, muodostavatko vaiheet loogisen ketjun, onko T0:ssa toimenpide, onko vastuut nimetty, näkyvätkö oletukset ja jääkö ristiriitoja. Voit ohittaa jokaisen huomion.',
    reviewStale: 'Polkua on muutettu arvioinnin jälkeen.',
    reviewWhen: 'Arvioi polku, kun kaikki vaiheet T4–T0 on täytetty. Arvioinnin voi toistaa muutosten jälkeen.',
    reviewNoPoints: 'Ei huomautettavaa.',
    severity: { warning: 'Huomio', note: 'Vinkki' },
    dismiss: 'Ohita',
    approve: 'Hyväksy toimintapolku',
    approveHint: 'Hyväksyntä avaa Villi kortti ‑vaiheen eikä lukitse polkua: muokkaamista voi jatkaa myös hyväksynnän jälkeen.',
    approved: 'Toimintapolku on hyväksytty',
    approvedHint: 'Polkua voi yhä muokata. Raportti ja villin kortin stressitesti käyttävät aina polun nykyistä versiota.',
    needsT0Action: 'Lisää vaiheeseen T0 ainakin yksi toimenpide.',
  },
  pathReport: {
    preferredIntro: 'Tavoiteltava tulevaisuus, jonka puolesta toimitaan, ja skenaarioista valitut piirteet, joille se rakentuu.',
    pathIntro: 'Toimintapolku tavoitteesta takaisin nykyhetkeen. Käännekohdat on korostettu.',
  },
};

export const foresightPathEn = {
  runAdmin: {
    acceptTitle: 'Scenarios for further work',
    publishTitle: 'Scenarios published to other modules',
    noRuns: 'No scenarios have been started yet.',
    noApprovedRuns: "No scenario's future images have been approved yet.",
    accept: 'Take on',
    leaveOut: 'Leave out',
    undecided: 'Not decided yet',
    allGoOn: 'Goes on automatically',
    published: 'Published',
    notPublished: 'Not published',
    publish: 'Publish',
    withdraw: 'Withdraw',
    withdrawHasContent: 'The impact map already has content built on this scenario, so it cannot be withdrawn.',
  },
  run: {
    waiting: 'The scenario "{{title}}" is waiting for the facilitator to take it on to further work. Meanwhile you can work on its scope or choose another scenario.',
    leftOut: 'The facilitator did not take the scenario "{{title}}" on to further work. Choose another scenario.',
    acceptance: { accepted: 'In further work', leftOut: 'Not taken on', waiting: 'Awaiting selection' },
    title: 'Scenario',
    lead: "Each foresight run is one of the Kuutio's scenarios: you scope its subject, choose its change drivers and build three future images, which lead to a preferred future and a backcasting path. Start a new scenario or continue one you started earlier.",
    existing: 'Scenarios started',
    new: 'New scenario',
    namePlaceholder: 'Name of the scenario, e.g. Risk management 2031',
    create: 'Start the scenario',
    continue: 'Continue this one',
    chosen: 'Chosen',
    briefFor: 'Brief of the scenario',
    listTitle: 'Choose a scenario',
    listLead: 'Choose the scenario you are working on in this step.',
    navList: 'Scenarios',
    state: { done: 'Done', open: 'In progress', waitsFor: 'Waiting for: {{step}}' },
    rename: 'Rename',
    editRun: 'Edit name and owner',
    owner: 'Owner',
    ownerPlaceholder: 'Owner (optional): who built the scenario and answers questions about it',
    ownerOf: 'Owner: {{name}}',
    chooseFirst: 'First choose the scenario you are working on, or start a new one in the Scope step.',
    next: 'Next step: {{step}}',
    stepsLabel: 'Foresight steps',
    stepOf: 'Step {{n}}/{{total}}',
  },
  preferred: {
    title: 'Preferred future',
    lead: "The preferred future is not one of the future images but a conscious choice you are prepared to act on. Take features from the scenario's future images: what to promote, what to avoid, what to adapt to and what you can influence. The AI drafts and points out tensions; the choice is yours.",
    questionsTitle: 'Guiding questions',
    questions: {
      mustBeTrue: 'What must be true in the target year?',
      prevent: 'What development do we want to prevent?',
      values: 'What values does our choice express?',
      inPractice: 'How would the change show in practice?',
    },
    featuresTitle: 'Features of the future images',
    featuresLead: 'Add a feature to one of the four groups. Each feature can be used once, and a choice can be returned to the list and grouped again.',
    noScenarios: 'The scenario has no approved future images. Approve them first.',
    kinds: { opportunity: 'Opportunity', risk: 'Risk' },
    takenAs: 'Added: {{group}}',
    returnToList: 'Return to the list',
    moveTo: 'Move to another group',
    addTo: 'Add to group…',
    groupsTitle: 'Chosen features',
    groups: { promote: 'Promote', avoid: 'Avoid', adaptTo: 'Adapt to', canInfluence: 'Can influence' },
    groupHints: {
      promote: 'A wanted development we strengthen with our own actions',
      avoid: 'An unwanted development we work against',
      adaptTo: 'A development we cannot influence but prepare for',
      canInfluence: 'Something whose direction the organisation itself can change, wanted or not',
    },
    fromFuture: 'From future image: {{title}}',
    own: 'Own feature',
    ownPlaceholder: 'Own feature',
    futureTitle: 'The future',
    valuesBasis: 'Values and goals the choice rests on',
    valuesBasisHint: 'Both the organisation\'s values (for example from its strategy) and your own view of the values and goals of this work belong here. The scope\'s goal says what is pursued; this says why. The values guide the whole path, not only this draft.',
    draftHint: 'The draft is built from the features and values you chose and does not change them. Read it through and correct what is said wrong: the final content is yours.',
    draft: 'Draft with AI',
    draftReplace: 'Replace and draft',
    draftNeedsFeatures: 'Choose some features first.',
    confirmOverwrite: 'The AI draft replaces the current description, success conditions, driver outcomes and tensions. The chosen features and the values and goals stay. Continue?',
    description: 'What the target year looks like',
    descriptionHint: 'Read the description through and check that everything is said right. The AI interprets your choices, and small misreadings are common.',
    successConditions: 'Success conditions: what is true in the target year',
    onePerLine: 'One condition per line',
    driverOutcomesTitle: 'The drivers in the preferred future',
    driverOutcomesLead: "How each driver looks in the target year. On approval these become the scenario's fourth future image, which future selection and the impact map can use.",
    tensionsTitle: 'Tensions to resolve',
    tensionResolved: 'dealt with',
    tensionsLead: 'The AI raised these from conflicts between the features you chose. Go through them with your own expertise: edit an imprecise one, remove one that misses the point, and mark one as dealt with once you have taken it into account. Tensions are not solved here: the solutions are built on the backcasting path. The tensions you keep go on to the path\'s AI and the report. No tension is mandatory: the future image can be approved with none of them marked.',
    approve: 'Approve the future',
    approved: "The preferred future is approved and saved as one of the scenario's future images. If you edit it, approve it again.",
  },
  backcasting: {
    title: 'Backcasting',
    lead: 'Build the path from the preferred future back to the present. Look at each stage as a whole: what must exist or happen at this stage for the next stage, and in the end the target state, to come true? Add conditions, turning points, decisions, capabilities, resources, partnerships and actions to the path as needed. When you open a stage, the AI first proposes how far along each dimension of the target state must be: accept, correct or drop the proposals before completing the stage. Guiding questions and drafts come on request; they are starting points, not answers.',
    timelineTitle: 'Path to the target year {{year}}',
    yearsHint: 'Click a stage to open it and a year to change it. T0 is now: if the work starts only next year, change its year.',
    overviewEmpty: 'No items yet',
    targetTitle: 'Target state {{year}}',
    targetColumn: 'Target year',
    targetEmpty: 'The success conditions are written in the preferred future.',
    targetConditions: 'Success conditions',
    targetDimensions: 'Dimensions of the target state',
    targetDimensionsHint: 'The target state in a few keywords, one per line, e.g. One shared data resource',
    targetDimensionsAdd: 'Add keywords',
    targetDimensionsEdit: 'Edit keywords',
    manyItems: 'This stage already has {{n}} items. Few, weighty items keep the path readable: merge or prune if you can.',
    stage: 'Stage',
    copyTo: 'Copy to stage',
    copyHint: 'The copy becomes its own item in the chosen stage, for you to edit:',
    stageYear: 'Year of stage {{stage}}',
    stagesLabel: 'Stages of the path',
    stageTitle: '{{stage}} · {{year}}',
    stageHints: {
      T4: 'The last stage before the target year: the target state has not been reached yet. What is ready by then, and what was the last decisive change?',
      T3: 'What had to be true for the last stage to be possible? Which turning point belongs here?',
      T2: 'Which decisions and capabilities did this stage have to achieve?',
      T1: 'What had to be in place for the change to get started?',
      T0: 'What starts now? The path needs at least one action in this stage.',
    },
    stageEmpty: 'Nothing in this stage yet.',
    freeEdit: 'Free editing',
    freeEditHint: 'Opens every stage at once, for filling in the path out of the T4→T0 order. It does not change the saved path.',
    stageGated: 'Backcasting runs from the future to the present: stage {{stage}} ({{year}}) is still empty. Start there, or allow free editing.',
    goToStage: 'Go to stage {{stage}}',
    addItem: 'Add an item',
    askAssist: 'Questions and drafts',
    kind: 'Kind',
    text: 'What happens or is true at this stage?',
    kinds: {
      condition: 'Condition', turning_point: 'Turning point', decision: 'Decision', capability: 'Capability',
      resource: 'Resource', partnership: 'Partnership', action: 'Action', indicator: 'Indicator',
    },
    kindHints: {
      condition: 'What must be true at this stage for the path to go on',
      turning_point: 'A turn after which the direction is different: the key points of the path',
      decision: 'Who decides, and what',
      capability: 'What must be known or mastered: skills and ways of working',
      resource: 'Money, time, people, premises, data',
      partnership: 'Who this is done with',
      action: 'A concrete deed with a doer and a time',
      indicator: 'How far along a dimension of the target state is by this stage\'s year',
    },
    showDetails: 'Responsibility, metric, obstacle, rationale…',
    hideDetails: 'Hide details',
    details: { responsibility: 'Responsibility', metric: 'Metric', obstacle: 'Obstacle', remedy: 'Remedy', rationale: 'Rationale' },
    detailHints: {
      responsibility: 'Who is responsible for this item',
      metric: 'How you can tell this has happened',
      obstacle: 'What could stop this item from happening',
      remedy: 'How the obstacle is overcome',
      rationale: 'Why this item belongs on the path at this stage',
    },
    fromAi: 'AI draft',
    dimension: 'Dimension',
    stageSteps: 'First go through the proposed indicators, then complete the stage yourself: what must exist or happen at this stage for the next stage to come true?',
    indicatorsTitle: 'Dimensions of the target state in {{year}}',
    indicatorsLead: 'How far along each dimension must be by this stage\'s year. The AI\'s proposals are a starting point: accept, edit or dismiss each one.',
    indicatorProposals: 'AI proposals',
    indicatorNone: 'No milestone at this stage',
    indicatorWrite: 'Write your own',
    suggestIndicators: 'Suggest indicators',
    suggestIndicatorsAgain: 'Suggest indicators again',
    needsDimensions: 'Write the dimensions of the target state as keywords in the target-year column, and the AI proposes an indicator for each, stage by stage.',
    metricSuggest: 'Suggest a metric',
    metricSuggestAgain: 'Suggest a better metric',
    metricProposal: 'AI suggestion',
    metricUse: 'Use',
    metricDrop: 'Dismiss',
    reviewSuggestion: 'Suggested for {{stage}}',
    reviewAdd: 'Add to the path',
    reviewAdded: 'Added to the path',
    changedByStressTest: 'Changed by the stress test',
    questionsTitle: 'Facilitating questions',
    questionsLead: 'The questions and drafts are indicative. If a term or a suggestion misses, skip it and write the item in your own words.',
    draftsTitle: 'Drafts',
    reviewTitle: 'Path review',
    review: 'Review the path',
    reviewAgain: 'Review again',
    reviewLead: 'The AI checks that the stages form a logical chain, that T0 has an action, that responsibilities are set, that assumptions are visible and that no contradictions are left. You can dismiss each point.',
    reviewStale: 'The path has changed since the review.',
    reviewWhen: 'Review the path once every stage T4–T0 has content. The review can be repeated after changes.',
    reviewNoPoints: 'Nothing to point out.',
    severity: { warning: 'Warning', note: 'Note' },
    dismiss: 'Dismiss',
    approve: 'Approve the path',
    approveHint: 'Approval opens the Wild card step and does not lock the path: you can keep editing after it.',
    approved: 'The path is approved',
    approvedHint: 'The path can still be edited. The report and the wild card stress test always use its current state.',
    needsT0Action: 'Add at least one action to stage T0.',
  },
  pathReport: {
    preferredIntro: 'The preferred future to act on, and the features of the scenarios it is built from.',
    pathIntro: 'The path from the goal back to the present. Turning points are highlighted.',
  },
};

export const foresightPathSv = {
  runAdmin: {
    acceptTitle: 'Scenarier för fortsatt arbete',
    publishTitle: 'Scenarier som publiceras för andra moduler',
    noRuns: 'Inga scenarier har påbörjats ännu.',
    noApprovedRuns: 'Inget scenarios framtidsbilder har godkänts ännu.',
    accept: 'Ta vidare',
    leaveOut: 'Lämna utanför',
    undecided: 'Inte valt ännu',
    allGoOn: 'Går vidare automatiskt',
    published: 'Publicerat',
    notPublished: 'Inte publicerat',
    publish: 'Publicera',
    withdraw: 'Dra tillbaka',
    withdrawHasContent: 'Effektkartan har redan innehåll byggt på det här scenariot, så publiceringen kan inte dras tillbaka.',
  },
  run: {
    waiting: 'Scenariot "{{title}}" väntar på att facilitatorn tar det vidare till fortsatt arbete. Under tiden kan du arbeta med dess avgränsning eller välja ett annat scenario.',
    leftOut: 'Facilitatorn tog inte scenariot "{{title}}" vidare till fortsatt arbete. Välj ett annat scenario.',
    acceptance: { accepted: 'I fortsatt arbete', leftOut: 'Inte valt', waiting: 'Väntar på val' },
    title: 'Scenario',
    lead: 'Varje framsyn är ett av Kuutions scenarier: du avgränsar det som granskas, väljer förändringskrafterna och bygger tre framtidsbilder, som leder till en önskad framtid och en handlingsväg. Börja ett nytt scenario eller fortsätt ett som du har påbörjat.',
    existing: 'Påbörjade scenarier',
    new: 'Nytt scenario',
    namePlaceholder: 'Scenariots namn, t.ex. Riskhantering 2031',
    create: 'Börja scenariot',
    continue: 'Fortsätt med det här',
    chosen: 'Valt',
    briefFor: 'Scenariots avgränsning',
    listTitle: 'Välj ett scenario',
    listLead: 'Välj det scenario du arbetar med i det här steget.',
    navList: 'Scenarier',
    state: { done: 'Klar', open: 'Pågår', waitsFor: 'Väntar på: {{step}}' },
    rename: 'Byt namn',
    editRun: 'Redigera namn och ägare',
    owner: 'Ägare',
    ownerPlaceholder: 'Ägare (frivilligt): vem som byggde scenariot och svarar på frågor om det',
    ownerOf: 'Ägare: {{name}}',
    chooseFirst: 'Välj först det scenario du arbetar med, eller börja ett nytt i steget Avgränsning.',
    next: 'Nästa steg: {{step}}',
    stepsLabel: 'Framsynens steg',
    stepOf: 'Steg {{n}}/{{total}}',
  },
  preferred: {
    title: 'Önskad framtid',
    lead: 'Den önskade framtiden är inte en av framtidsbilderna utan ett medvetet val som ni är beredda att arbeta för. Ta drag ur scenariots framtidsbilder: vad som ska främjas, vad som ska undvikas, vad ni ska anpassa er till och vad ni kan påverka. AI:n skissar och lyfter fram spänningar; valet är ditt.',
    questionsTitle: 'Hjälpfrågor',
    questions: {
      mustBeTrue: 'Vad måste vara sant målåret?',
      prevent: 'Vilken utveckling vill vi förhindra?',
      values: 'Vilka värden uttrycker vårt val?',
      inPractice: 'Hur skulle förändringen synas i praktiken?',
    },
    featuresTitle: 'Drag i framtidsbilderna',
    featuresLead: 'Lägg till ett drag i en av de fyra grupperna. Varje drag kan användas en gång, och ett val kan återföras till listan och grupperas på nytt.',
    noScenarios: 'Scenariot har inga godkända framtidsbilder. Godkänn dem först.',
    kinds: { opportunity: 'Möjlighet', risk: 'Risk' },
    takenAs: 'Tillagt: {{group}}',
    returnToList: 'Återför till listan',
    moveTo: 'Flytta till en annan grupp',
    addTo: 'Lägg till i grupp…',
    groupsTitle: 'Valda drag',
    groups: { promote: 'Främja', avoid: 'Undvika', adaptTo: 'Anpassa sig till', canInfluence: 'Kan påverka' },
    groupHints: {
      promote: 'En önskad utveckling som vi stärker med egna åtgärder',
      avoid: 'En oönskad utveckling som vi motverkar',
      adaptTo: 'En utveckling vi inte kan påverka men förbereder oss för',
      canInfluence: 'Något vars riktning organisationen själv kan ändra, önskat eller inte',
    },
    fromFuture: 'Ur framtidsbilden: {{title}}',
    own: 'Eget drag',
    ownPlaceholder: 'Eget drag',
    futureTitle: 'Framtidsbilden',
    valuesBasis: 'Värden och mål som valet bygger på',
    valuesBasisHint: 'Hit hör både organisationens värden (till exempel ur dess strategi) och din egen syn på utvecklingsarbetets värden och mål. Avgränsningens mål säger vad som eftersträvas; detta säger varför. Värdena styr hela handlingsvägen, inte bara detta utkast.',
    draftHint: 'Utkastet bygger på de drag och värden du valt och ändrar dem inte. Läs igenom texten och rätta det som sagts fel: det slutliga innehållet är ditt.',
    draft: 'Skissa med AI',
    draftReplace: 'Ersätt och skissa',
    draftNeedsFeatures: 'Välj några drag först.',
    confirmOverwrite: 'AI:ns utkast ersätter nuvarande beskrivning, villkor för framgång, drivkrafternas beskrivningar och spänningar. De valda dragen samt värden och mål finns kvar. Fortsätta?',
    description: 'Hur målåret ser ut',
    descriptionHint: 'Läs igenom beskrivningen och kontrollera att allt är rätt sagt. AI:n tolkar dina val, och små feltolkningar är vanliga.',
    successConditions: 'Villkor för framgång: vad som är sant målåret',
    onePerLine: 'Ett villkor per rad',
    driverOutcomesTitle: 'Förändringskrafterna i den önskade framtiden',
    driverOutcomesLead: 'Hur varje förändringskraft ser ut målåret. När den godkänns blir de scenariots fjärde framtidsbild, som valet av framtidsbild och effektkartan kan använda.',
    tensionsTitle: 'Spänningar att lösa',
    tensionResolved: 'behandlad',
    tensionsLead: 'AI:n lyfte fram dessa ur motsättningar mellan de drag du valt. Gå igenom dem utifrån din sakkunskap: redigera en oprecis, ta bort en som missar poängen och markera en som behandlad när du har beaktat den. Spänningarna löses inte här: lösningarna byggs på backcasting-vägen. De spänningar du behåller förs vidare till vägens AI och till rapporten. Ingen spänning är obligatorisk: framtidsbilden kan godkännas utan att någon är markerad.',
    approve: 'Godkänn framtidsbilden',
    approved: 'Den önskade framtiden är godkänd och sparad som en av scenariots framtidsbilder. Om du redigerar den, godkänn den igen.',
  },
  backcasting: {
    title: 'Backcasting',
    lead: 'Bygg vägen från den önskade framtiden tillbaka till nuet. Se på varje steg som en helhet: vad måste finnas eller hända i det här steget för att nästa steg, och till sist måltillståndet, ska kunna bli verklighet? Lägg till villkor, vändpunkter, beslut, förmågor, resurser, partnerskap och åtgärder på vägen efter behov. När du öppnar ett steg föreslår AI:n först hur långt varje dimension av måltillståndet måste ha kommit: godkänn, rätta eller ta bort förslagen innan du kompletterar steget. Stödfrågor och utkast får du på begäran; de är utgångspunkter, inte svar.',
    timelineTitle: 'Vägen till målåret {{year}}',
    yearsHint: 'Klicka på ett steg för att öppna det och på ett år för att ändra det. T0 är nu: om arbetet börjar först nästa år, ändra dess år.',
    overviewEmpty: 'Inga punkter ännu',
    targetTitle: 'Måltillstånd {{year}}',
    targetColumn: 'Målår',
    targetEmpty: 'Villkoren för framgång skrivs i den önskade framtiden.',
    targetConditions: 'Villkor för framgång',
    targetDimensions: 'Måltillståndets dimensioner',
    targetDimensionsHint: 'Måltillståndet i några nyckelord, ett per rad, t.ex. En gemensam informationsresurs',
    targetDimensionsAdd: 'Lägg till nyckelord',
    targetDimensionsEdit: 'Redigera nyckelorden',
    manyItems: 'Steget har redan {{n}} punkter. Få, tunga punkter håller vägen läsbar: slå ihop eller gallra om du kan.',
    stage: 'Steg',
    copyTo: 'Kopiera till steg',
    copyHint: 'Kopian blir en egen punkt i det valda steget, som du kan redigera:',
    stageYear: 'År för steg {{stage}}',
    stagesLabel: 'Vägens steg',
    stageTitle: '{{stage}} · {{year}}',
    stageHints: {
      T4: 'Det sista steget före målåret: måltillståndet är ännu inte nått. Vad är klart då, och vilken var den sista avgörande förändringen?',
      T3: 'Vad måste vara sant för att det sista steget skulle vara möjligt? Vilken vändpunkt hör hit?',
      T2: 'Vilka beslut och förmågor måste det här steget åstadkomma?',
      T1: 'Vad måste finnas på plats för att förändringen skulle komma i gång?',
      T0: 'Vad börjar nu? Vägen behöver minst en åtgärd i det här steget.',
    },
    stageEmpty: 'Inget i det här steget ännu.',
    freeEdit: 'Fri redigering',
    freeEditHint: 'Öppnar alla steg på en gång, när du vill komplettera vägen i annan ordning än T4→T0. Den sparade vägen påverkas inte.',
    stageGated: 'Backcasting går från framtiden till nuet: steget {{stage}} ({{year}}) är ännu tomt. Börja där, eller tillåt fri redigering.',
    goToStage: 'Gå till steg {{stage}}',
    addItem: 'Lägg till en punkt',
    askAssist: 'Hjälpfrågor och utkast',
    kind: 'Typ',
    text: 'Vad händer eller är sant i det här steget?',
    kinds: {
      condition: 'Villkor', turning_point: 'Vändpunkt', decision: 'Beslut', capability: 'Kompetens',
      resource: 'Resurs', partnership: 'Partnerskap', action: 'Åtgärd', indicator: 'Indikator',
    },
    kindHints: {
      condition: 'Vad som måste vara sant i detta steg för att vägen ska fortsätta',
      turning_point: 'En vändning efter vilken riktningen är en annan: vägens viktigaste punkter',
      decision: 'Vem som beslutar, och vad',
      capability: 'Vad som måste kunnas eller behärskas: kompetens och arbetssätt',
      resource: 'Pengar, tid, personer, lokaler, data',
      partnership: 'Vem detta görs tillsammans med',
      action: 'En konkret handling med en utförare och en tidpunkt',
      indicator: 'Hur långt en dimension av måltillståndet har kommit det här stegets år',
    },
    showDetails: 'Ansvar, mätare, hinder, motivering…',
    hideDetails: 'Dölj detaljer',
    details: { responsibility: 'Ansvar', metric: 'Mätare', obstacle: 'Hinder', remedy: 'Lösning på hindret', rationale: 'Motivering' },
    detailHints: {
      responsibility: 'Vem som ansvarar för denna punkt',
      metric: 'Hur man ser att detta har skett',
      obstacle: 'Vad som kan hindra denna punkt',
      remedy: 'Hur hindret övervinns',
      rationale: 'Varför denna punkt hör till vägen i just detta steg',
    },
    fromAi: 'AI-utkast',
    dimension: 'Dimension',
    stageSteps: 'Gå först igenom de föreslagna indikatorerna, och komplettera sedan steget själv: vad måste finnas eller hända i det här steget för att nästa steg ska kunna bli verklighet?',
    indicatorsTitle: 'Måltillståndets dimensioner {{year}}',
    indicatorsLead: 'Hur långt varje dimension måste ha kommit det här stegets år. AI:ns förslag är en utgångspunkt: godkänn, redigera eller avfärda vart och ett.',
    indicatorProposals: 'AI:ns förslag',
    indicatorNone: 'Ingen delmilstolpe i det här steget',
    indicatorWrite: 'Skriv själv',
    suggestIndicators: 'Föreslå indikatorer',
    suggestIndicatorsAgain: 'Föreslå indikatorer igen',
    needsDimensions: 'Skriv måltillståndets dimensioner som nyckelord i målårets kolumn, så föreslår AI:n en indikator för var och en, steg för steg.',
    metricSuggest: 'Föreslå en mätare',
    metricSuggestAgain: 'Föreslå en bättre mätare',
    metricProposal: 'AI:ns förslag',
    metricUse: 'Använd',
    metricDrop: 'Avfärda',
    reviewSuggestion: 'Förslag till {{stage}}',
    reviewAdd: 'Lägg till i vägen',
    reviewAdded: 'Tillagd i vägen',
    changedByStressTest: 'Ändrad i stresstestet',
    questionsTitle: 'Hjälpfrågor',
    questionsLead: 'Frågorna och utkasten är vägledande. Om en term eller ett förslag inte träffar rätt, hoppa över det och skriv punkten med egna ord.',
    draftsTitle: 'Utkast',
    reviewTitle: 'Granskning av vägen',
    review: 'Granska vägen',
    reviewAgain: 'Granska igen',
    reviewLead: 'AI:n kontrollerar att stegen bildar en logisk kedja, att T0 har en åtgärd, att ansvar är fastställt, att antagandena syns och att inga motsägelser lämnas olösta. Du kan avfärda varje punkt.',
    reviewStale: 'Vägen har ändrats efter granskningen.',
    reviewWhen: 'Bedöm vägen när alla steg T4–T0 har innehåll. Bedömningen kan upprepas efter ändringar.',
    reviewNoPoints: 'Inget att anmärka.',
    severity: { warning: 'Varning', note: 'Tips' },
    dismiss: 'Avfärda',
    approve: 'Godkänn handlingsvägen',
    approveHint: 'Godkännandet öppnar steget Wild card och låser inte vägen: du kan fortsätta redigera också efter det.',
    approved: 'Handlingsvägen är godkänd',
    approvedHint: 'Vägen kan fortfarande redigeras. Rapporten och wild card-stresstestet använder alltid dess nuvarande version.',
    needsT0Action: 'Lägg till minst en åtgärd i steg T0.',
  },
  pathReport: {
    preferredIntro: 'Den önskade framtiden att arbeta för, och de drag i scenarierna som den bygger på.',
    pathIntro: 'Vägen från målet tillbaka till nuet. Vändpunkterna är framhävda.',
  },
};
